window.onscroll = function() {
    floatingFilter();
}
window.onresize = function() {
    floatingFilter();
}

window.onload = function() {
    floatingFilter();
}

function floatingFilter(){
    heightElm = document.querySelector(".vehicles-filters__container");
    stickyElem = document.querySelector(".vehicles-filters__sidebar");
    footerElem = document.querySelector(".footer");

}
